import React, { FunctionComponent } from "react";


interface HeroCarouselIndicatorProps {
    clickHandler?: (e: (React.MouseEvent | React.KeyboardEvent)) => void;
    isSelected?: boolean;
    index: number;
    baseClassName?: string;
}

const HeroCarouselIndicator: FunctionComponent<HeroCarouselIndicatorProps> = ({ isSelected = false, index, baseClassName = 'controls__dots__item' }) => {
    const className = isSelected ? baseClassName + ' ' + baseClassName + '--selected' : baseClassName;

    return (
        <li className={className} value={index}/>
    );
}

export default HeroCarouselIndicator;
